<script>
    import LyInputText from './LyInputText.svelte';
    import { ValueService } from '../../services/ValueService.js';

    let {
        name = null,
        placeholder = null,
        id = null,
        label = null,
        required = false,
        newPassword = false,
        value = $bindable(''),
        thisRef = $bindable(null),
        ...restProps
    } = $props();

    const useAutoComplete = $derived(ValueService.toBool(newPassword) ? 'new-password' : 'current-password');
</script>

<LyInputText
    {...restProps}
    bind:value
    bind:thisRef
    type="password"
    {id}
    {name}
    {label}
    {placeholder}
    autocomplete={useAutoComplete}
    {required} />
